import { StepIds } from '~/components/premarketplace/partner-config';
import { CustomerFormValues } from '~/types/marketplace';

type ParentEventType = 'view' | 'track';
type EventActionType = 'opened' | 'closed' | 'next' | 'back' | 'submitted' | 'skipped';

type ParentEventPayload = {
  stepName?: StepIds;
  action?: EventActionType;
  payload?: Record<string, string | string[] | number | boolean | null> | Partial<CustomerFormValues>;
};

const ALLOWED_PARENT_ORIGINS = ['https://www.brighte.com.au'];
const LOCALHOST_HOSTNAMES = new Set(['localhost', '127.0.0.1', '0.0.0.0']);

const getOrigin = (value: string | undefined | null) => {
  if (!value) return null;

  try {
    return new URL(value).origin;
  } catch {
    return null;
  }
};

const getParentOrigin = () => {
  const ancestorOrigins = (window.location as Location & { ancestorOrigins?: DOMStringList }).ancestorOrigins;
  const ancestorOrigin = ancestorOrigins?.length ? ancestorOrigins[0] : null;

  return getOrigin(ancestorOrigin) ?? getOrigin(document.referrer);
};

const isLocalDevelopmentOrigin = (origin: string) => {
  if (!import.meta.env.DEV) return false;

  try {
    return LOCALHOST_HOSTNAMES.has(new URL(origin).hostname);
  } catch {
    return false;
  }
};

export const sendParentEvent = (type: ParentEventType, payload?: ParentEventPayload) => {
  const targetOrigin = getParentOrigin();

  if (!targetOrigin || (!ALLOWED_PARENT_ORIGINS.includes(targetOrigin) && !isLocalDevelopmentOrigin(targetOrigin))) {
    return;
  }

  window.parent.postMessage({ type, payload: JSON.stringify(payload) }, targetOrigin);
};
